<app-banner [heading]="'Camps'" [detail]="'Tagore Global School - Kurukshetra.'"></app-banner>

<section id="events" class="events">
    <div class="container" data-aos="fade-up">
      <h1><b>SUMMER CAMP 1ST JUNE, 2021 TO 9TH, JUNE 2021 </b></h1>
      <div class="row">
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/48.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/47.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/46.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/45.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/44.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/43.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/422.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/41.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/40.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/39.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/38.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/37.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/36.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/35.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/34.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/33.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/322.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/31.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/30.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/29.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/28.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/27.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/26.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/25.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/24.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/23.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/222.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/21.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/20.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/19.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/18.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/17.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/16.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/16.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/152.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/142.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/132.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/122.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/112.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/102.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/92.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/82.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/72.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/62.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/52.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/42.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/32.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div><div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/22.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activitysummercamp/15.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
</div>
      <h1><b>SPORTS CAMP 16TH MARCH, 2021 TO 26TH MARCH, 2021</b></h1>
      <div class="row">

      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/1.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/2.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/3.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/4.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/5.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/6.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/7.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/8.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/9.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/10.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/11.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/12.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/13.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
      <div class="col-md-4 d-flex align-items-stretch">
          <div class="card">
            <div class="card-img">
              <img src="assets/img/gallery/activity4/14.jpg" alt="best school in kurukshetra">
            </div>
           
          </div>
      </div>
          
          
          <!--Row  -->
      </div>

    </div>
  </section>